import httpClient from "../utils/httpClient";

export const ContactUsInsert = async (params) => {
    const response = await httpClient.post(`/ContactUs/insert-contactus`, params);
    return response.data;
};

export const ContactUsEnquiryInsert = async (params) => {
    const response = await httpClient.post(`/ContactUs/insert-contactusenquiry`, params);
    return response.data;
};
